
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { SupabaseAuthSection } from '@/components/auth/SupabaseAuthSection';

export default function Login() {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSupabaseAuthSuccess = () => {
    toast({
      title: "تم تسجيل الدخول بنجاح",
      description: "مرحباً بك في النظام"
    });
    setTimeout(() => {
      navigate('/dashboard');
    }, 1000);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <div className="w-full max-w-md space-y-6">
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">تسجيل الدخول</h1>
          <p className="text-gray-600">نظام إدارة شركة السياحة</p>
        </div>

        {/* نظام تسجيل الدخول */}
        <Card>
          <CardHeader>
            <CardDescription className="text-center">
              استخدم بريدك الإلكتروني وكلمة المرور للدخول إلى النظام
            </CardDescription>
          </CardHeader>
          <CardContent>
            <SupabaseAuthSection onSuccess={handleSupabaseAuthSuccess} />
          </CardContent>
        </Card>

        <Card className="bg-blue-50 border-blue-200">
          <CardContent className="pt-6">
            <div className="text-xs text-blue-700 text-center space-y-1">
              <p>• المستخدمون الجدد سيحتاجون لموافقة المدير للوصول للنظام</p>
              <p>• تواصل مع مدير النظام لتفعيل حسابك بعد التسجيل</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
